import script from "./desktopRedcodeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./desktopRedcodeTable.vue?vue&type=script&setup=true&lang=js"

import "./desktopRedcodeTable.vue?vue&type=style&index=0&id=eaa895b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa895b8"]])

export default __exports__